import * as React from "react";

function SvgBookmark(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      width={props.size}
      height={props.size}
      style={{
        verticalAlign: "-.143em",
        msTransform: "rotate(360deg)",
        WebkitTransform: "rotate(360deg)",
      }}
      viewBox="0 0 28 28"
      transform="rotate(360)"
      {...props}
    >
      <path
        d="M6 6.75A3.25 3.25 0 019.25 3.5h9.5A3.25 3.25 0 0122 6.75v18a.75.75 0 01-1.203.598L14 20.19l-6.797 5.157A.75.75 0 016 24.75v-18zM9.25 5A1.75 1.75 0 007.5 6.75v16.49l6.047-4.587a.75.75 0 01.906 0L20.5 23.24V6.75A1.75 1.75 0 0018.75 5h-9.5z"
        fill="#626262"
      />
    </svg>
  );
}

export default SvgBookmark;

